import React from "react";

export default function ReportsDisplay({ data }) {
  if (!data || data.length === 0) return null;

  return (
    <div
      style={{
        marginBottom: "30px",
        padding: "30px",
        backgroundColor: "#f9fafb",
        borderRadius: "12px",
        border: "1px solid #e5e7eb"
      }}
    >
      <h2 style={{ fontSize: "24px", fontWeight: "600", marginBottom: "20px" }}>
        📊 Company Reports
      </h2>

      <div style={{ display: "grid", gap: "15px" }}>
        {data
          .sort((a, b) => b.report_year - a.report_year)
          .map((report, idx) => (
            <div
              key={idx}
              style={{
                padding: "20px",
                backgroundColor: "white",
                borderRadius: "10px",
                border: "1px solid #e5e7eb"
              }}
            >
              <div style={{ fontWeight: "600" }}>
                {report.report_type} – {report.report_year}
              </div>

              <a
                href={report.report_url}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#4f46e5", fontSize: "14px" }}
              >
                📄 View Report →
              </a>
            </div>
          ))}
      </div>
    </div>
  );
}
